<template>
  <div class="multiselectdropdown-div">
    <MultiSelect v-model="selectedValues" :options="options" :showToggleAll=false optionLabel="label"
      :placeholder="placeholder" :maxSelectedLabels="1" class="multiselectdropdown" @change="onMultiSelectChange"
      selectedItemsLabel='{0} selected' :selectionLimit="limit" />
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 Omics Data Automation, Inc.
// Copyright (c) 2023 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.
import { computed, defineEmits, defineExpose, defineProps, ref, watch } from 'vue'
import MultiSelect from 'primevue/multiselect'

const selectedValues = ref([])
const previousSelectedValues = ref([])
const emit = defineEmits(['selected-values-changed'])
const props = defineProps({
  defaultOptions: {
    type: Array,
    required: true,
  },
  options: {
    type: Array,
    required: true,
  },
  department: {
    type: String,
    required: true,
  },
  limit: {
    type: Number,
    default: null,
  },
  placeholder: {
    type: String,
    default: 'Select Physician',
  },
})

const options = computed(() => props.options)

watch(() => props.defaultOptions, (newDefaultOptions) => {
  selectedValues.value = newDefaultOptions
  previousSelectedValues.value = newDefaultOptions
}, { immediate: true })

const onMultiSelectChange = () => {
  const newlySelectedValues = selectedValues.value
    .filter(value => !previousSelectedValues.value.includes(value))
    .map(value => ({
      ...value,
      is_selected: true,
    }))
  const newlyDeselectedValues = previousSelectedValues.value.filter(value => !selectedValues.value.includes(value)).map(value => ({ ...value, is_selected: false }))
  previousSelectedValues.value = selectedValues.value.slice()
  emit('selected-values-changed', newlySelectedValues.length ? newlySelectedValues : newlyDeselectedValues)
}

defineExpose({
  selectedValues,
})
</script>

<style>
.multiselectdropdown-div .multiselectdropdown {
  width: 160px;
  font-size: 12px;
}

.multiselectdropdown-div .p-multiselect .p-multiselect-label.p-placeholder {
  color: var(--Primary);
  font-size: 12px
}

.p-multiselect-panel .p-multiselect-items {
  padding: 0;
  font-size: 12px;
}
</style>
